<template>
  <div class="collab-opportunity-header" :class="{ active: isActive }">
    <div class="step-number-or-icon">
      <IconEmbedded v-if="stepNumber == null" :name="icon" :size="24" />
      <span v-else class="step-number">{{ stepNumber }}</span>
    </div>
    <div class="title-and-description">
      <div class="title">{{ title }}</div>
      <div class="description">{{ description }}</div>
    </div>
    <IconEmbedded v-if="stepNumber != null" class="header-icon" :name="icon" />
  </div>
</template>

<script setup lang="ts">
import IconEmbedded from "@components/ui/IconEmbedded.vue";
import { IconName } from "@contracts/IconName";

defineProps<{
  isActive: boolean;
  title: string;
  description: string;
  icon: IconName;
  /** When omitted, icon is shown in place of the step number (left side) instead of on the right. */
  stepNumber?: number;
}>();
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";
.collab-opportunity-header {
  width: 100%;
  display: flex;
  align-items: flex-start;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-radius: 4px;

  &.active {
    .step-number {
      background-color: $dark-green;
      color: white;
    }
  }
}

.step-number-or-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;
  min-width: 2rem;
  margin-right: 1rem;
  flex-shrink: 0;
}

.step-number {
  height: 2rem;
  width: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  padding: 0px;
  background-color: white;
}

.title-and-description {
  flex: 1;
  min-width: 0;
}

.title {
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 0.75rem;
  // line-height: 1.4;
}
.description {
  font-size: 1rem;
  font-weight: 400;
  // line-height: 1.4;
}
.header-icon {
  margin-left: 16px;
  width: 34px;
  height: 34px;
  margin-left: auto;
}
// tablet and smaller
@media (max-width: $tablet-max-width) {
  .step-number-or-icon {
    display: none;
  }
  .step-number {
    display: none;
  }
  .collab-opportunity-header {
    align-items: center;
  }
  .title {
    margin: 0;
    font-size: 1.5rem !important;
  }
  .description {
    display: none;
  }
  .header-icon {
    display: none;
  }
}
</style>
